import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { ClienteDescripcionPaqueteEdit } from "./edit";
const EditModal = ClienteDescripcionPaqueteEdit;
type Entity = models.ClienteDescripcionPaqueteDTO;
type Column = kea.Grid2Column<Entity>;

export interface Props {
    idCliente: number;
    readonly?: boolean;
}

export interface BotonesDeps {
    onEliminar: (item: Entity) => void;
}

function botones(deps: BotonesDeps): kea.Grid2Column<Entity, undefined> {
    const columna = kea.columnaBotones<Entity>([
        {
            tooltip: "Eliminar",
            style: "danger",
            iconClass: fa("trash"),
            onClick: deps.onEliminar
        }
    ]);

    return {
        ...columna,
        cell: x => ({
            ...columna.cell(x),
            style: () => ({
                maxWidth: "300px"
            })
        })
    }
}

export const columnasFijas: Column[] = [
    { title: "Nombre descripción paquete", cell: x => ({ data: x.NombrePaquete }) },
    { title: "Descripción paquete visible solo para clientes relacionados", cell: x => ({ data: x.PaqueteVisibleSoloParaRelacionados }) },
];

/**Obtiene las columnas del grid */
export function columnas(deps: BotonesDeps): kea.Grid2Column<Entity, undefined>[] {
    return [botones(deps), ...columnasFijas];
}

/**
* Listado de ClienteDescripcionPaqueteDTO
*/
class ClienteDescripcionPaqueteListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();

    idCliente = (x: Props) => x.idCliente;
    paquetesCliente = createSelectorRx(this.idCliente, idCliente => observeResource(resources.ClientePaquete.ObtenerClienteDescripcionesPaquetes, idCliente));

    onAgregar = async () => {
        var idCliente = this.idCliente(this.props)
        const result = await this.modals.showModal(EditModal, idCliente, []);
        if (result.result) {
            await resources.ClientePaquete.Add(idCliente, result.value);
        }
    }

    onEliminar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", item.NombrePaquete);
        if (ok) {
            await resources.ClientePaquete.Delete(item.IdRegistro);
        }
    }

    render() {
        const cols = columnas(this);
        const paquetesCliente = this.paquetesCliente(this.props);

        return (
            <div>
                <kea.Title titulo="Descripciones Paquetes" onAgregar={this.onAgregar} />
                <kea.Grid2 items={paquetesCliente} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const ClienteDescripcionPaqueteList = componentToRx(ClienteDescripcionPaqueteListNoRx);



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/clientes/edit/componentes/tabs/descripcionpaquetes/list.tsx